// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2ra2p","label":"Labeled_label__3gitI","divider":"Labeled_divider__3mo_n"};